var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgJourney = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 44,
  height: 44,
  fill: "none"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 44,
  height: 44,
  fill: "url(#journey_svg__a)",
  rx: 22
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "url(#journey_svg__b)",
  d: "M18.293 13.7H15.12a1.336 1.336 0 0 1-1.336-1.335v-5.03c0-.738.598-1.336 1.336-1.336h2.178a2.33 2.33 0 0 1 2.33 2.33v4.036c0 .738-.598 1.336-1.336 1.336Z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#journey_svg__c)",
  d: "M14.655 11.815a.608.608 0 0 1-.608-.608V7.275a.608.608 0 1 1 1.215 0v3.932a.608.608 0 0 1-.607.608Z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#journey_svg__d)",
  d: "M25.699 13.7h3.172c.738 0 1.336-.597 1.336-1.335v-5.03c0-.738-.598-1.336-1.336-1.336h-2.178a2.33 2.33 0 0 0-2.33 2.33v4.036c0 .738.598 1.336 1.336 1.336Z"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#journey_svg__e)",
  d: "M29.342 11.815a.608.608 0 0 0 .608-.608V7.275a.608.608 0 0 0-1.216 0v3.932c0 .336.272.608.608.608Z"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#journey_svg__f)",
  d: "m17.336 36.962-.467-.21a.441.441 0 0 1-.26-.402v-1.247h1.35v1.457c0 .32-.331.534-.623.402Z"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#journey_svg__g)",
  d: "m16.61 35.491 1.29 1.29a.437.437 0 0 0 .058-.221v-1.457H16.61v.388Z"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#journey_svg__h)",
  d: "m27.605 36.962-.466-.21a.441.441 0 0 1-.26-.402v-1.247h1.349v1.457c0 .32-.33.534-.623.402Z"
})), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#journey_svg__i)",
  d: "m26.879 35.491 1.29 1.29a.437.437 0 0 0 .059-.221v-1.457h-1.35v.388Z"
})), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#journey_svg__j)",
  d: "M29.986 35.491H14.01a1.037 1.037 0 0 1-1.037-1.037v-3.097c0-.573.464-1.037 1.037-1.037h15.976c.573 0 1.038.464 1.038 1.037v3.097c0 .573-.465 1.037-1.038 1.037Z"
})), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#journey_svg__k)",
  d: "M31.024 34.454v-3.097c0-.573-.465-1.037-1.038-1.037H14.012c.103.128.216.248.336.36l4.811 4.811h10.827c.573 0 1.038-.464 1.038-1.037Z"
})), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#journey_svg__l)",
  d: "m17.645 30.339 5.152 5.152h-5.152v-5.152Z"
})), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#journey_svg__m)",
  d: "M31.025 34.453v-.792l-3.322-3.322v5.152h2.285c.573 0 1.037-.465 1.037-1.038Z"
})), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#journey_svg__n)",
  d: "M17.642 30.32h-1.349v5.17h1.349v-5.17Z"
})), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#journey_svg__o)",
  d: "M27.7 30.32h-1.348v5.17H27.7v-5.17Z"
})), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#journey_svg__p)",
  d: "M33.278 23.73a.462.462 0 1 0 0-.923.462.462 0 0 0 0 .923Z"
})), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#journey_svg__q)",
  d: "M10.72 23.73a.462.462 0 1 0 0-.923.462.462 0 0 0 0 .923Z"
})), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#journey_svg__r)",
  d: "m13.53 21.956-1.226.188a1.807 1.807 0 0 0-1.51 2.103c.128.7.283 1.397.467 2.092.2.757.812 1.332 1.58 1.489.549.112 1.096.19 1.641.238l-.952-6.11Z"
})), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#journey_svg__s)",
  d: "m13.53 21.956-1.226.188a1.807 1.807 0 0 0-1.51 2.103l.01.048 3.661 3.661-.935-6Z"
})), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#journey_svg__t)",
  d: "m13.221 21.738-1.226.189a1.807 1.807 0 0 0-1.508 2.105c.021.12.13.205.251.2a9.34 9.34 0 0 0 2.79-.531l-.307-1.963Z"
})), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#journey_svg__u)",
  d: "m30.468 21.956 1.226.188a1.807 1.807 0 0 1 1.51 2.103c-.128.7-.284 1.397-.467 2.092a2.056 2.056 0 0 1-1.58 1.489c-.549.112-1.096.19-1.641.238l.952-6.11Z"
})), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#journey_svg__v)",
  d: "m31.695 22.145-.346-.054-.134 1.842 1.699 1.699c.108-.46.206-.922.29-1.385a1.807 1.807 0 0 0-1.509-2.102Z"
})), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#journey_svg__w)",
  d: "m30.775 21.738 1.226.189a1.807 1.807 0 0 1 1.509 2.105.246.246 0 0 1-.252.2 9.34 9.34 0 0 1-2.79-.531l.307-1.963Z"
})), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#journey_svg__x)",
  d: "M28.261 31.46c-4.174 1.174-8.35 1.174-12.524 0a3.423 3.423 0 0 1-2.43-2.661 44.884 44.884 0 0 1 0-16.82 3.423 3.423 0 0 1 2.43-2.66c4.173-1.174 8.35-1.174 12.524 0a3.423 3.423 0 0 1 2.43 2.66 44.888 44.888 0 0 1 0 16.82 3.423 3.423 0 0 1-2.43 2.66Z"
})), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#journey_svg__y)",
  d: "M12.816 25.6c.125 1.067.288 2.133.49 3.199a3.423 3.423 0 0 0 2.43 2.66c4.174 1.174 8.35 1.174 12.524 0a3.423 3.423 0 0 0 2.43-2.66c.202-1.066.365-2.133.49-3.199H12.816Z"
})), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#journey_svg__z)",
  d: "m13.264 12.205-.05.272-.085.495v.002c.055.332.114.664.177.995.147.78.558 1.47 1.14 1.97l14.952 14.95a3.432 3.432 0 0 0 1.293-2.09 44.888 44.888 0 0 0 0-16.82 3.432 3.432 0 0 0-.942-1.784 3.505 3.505 0 0 0-.168-.157l-.015-.014a3.399 3.399 0 0 0-.12-.099l-.075-.059a3.761 3.761 0 0 0-.422-.27l-.053-.027a3.324 3.324 0 0 0-.17-.082l-.035-.015a3.335 3.335 0 0 0-.195-.078l-.018-.006a3.41 3.41 0 0 0-.218-.07 24.15 24.15 0 0 0-1.956-.464 22.878 22.878 0 0 0-4.306-.416 22.191 22.191 0 0 0-2.74.168 23.547 23.547 0 0 0-3.522.712 3.39 3.39 0 0 0-1.593.984 3.435 3.435 0 0 0-.837 1.677c-.015.075-.028.15-.042.226Z"
})), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#journey_svg__A)",
  d: "M21.444 16.189h-.51v3.353a.462.462 0 0 0-.071.711l2.6 2.6a.462.462 0 1 0 .625-.676.432.432 0 0 0-.024-.027l-.02-.019V18.79l-2.6-2.6Z"
})), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#journey_svg__B)",
  d: "M23.065 17.015h-.51v3.354a.46.46 0 0 0-.072.711l2.6 2.6a.462.462 0 1 0 .627-.677.46.46 0 0 0-.024-.026l-.02-.019v-3.342l-2.601-2.6Z"
})), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#journey_svg__C)",
  d: "M21.444 16.189h-.51v3.572h.51V16.19Z"
})), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#journey_svg__D)",
  d: "M21.188 20.389a.462.462 0 1 0 0-.924.462.462 0 0 0 0 .924Z"
})), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#journey_svg__E)",
  d: "M23.065 17.015h-.51v3.573h.51v-3.573Z"
})), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#journey_svg__F)",
  d: "M22.81 21.215a.462.462 0 1 0 0-.923.462.462 0 0 0 0 .923Z"
})), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#journey_svg__G)",
  d: "M28.26 9.318c-4.173-1.173-8.35-1.173-12.524 0a3.423 3.423 0 0 0-2.43 2.661c-.063.332-.122.664-.177.996.055.331.114.663.177.995a3.423 3.423 0 0 0 2.43 2.66c4.173 1.175 8.35 1.175 12.524 0a3.423 3.423 0 0 0 2.43-2.66c.063-.332.122-.664.177-.996a46.735 46.735 0 0 0-.177-.995 3.423 3.423 0 0 0-2.43-2.66Z"
})), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#journey_svg__H)",
  d: "M28.258 9.318c-4.174-1.173-8.351-1.173-12.525 0a3.397 3.397 0 0 0-1.508.897 3.097 3.097 0 0 0-.121.47 4.705 4.705 0 0 0 .007 1.768 3.099 3.099 0 0 0 2.197 2.412c3.79 1.067 7.584 1.067 11.375 0a3.1 3.1 0 0 0 2.197-2.412l.006-.027c.108-.575.11-1.165.002-1.74l-.008-.038a3.109 3.109 0 0 0-.114-.433 3.398 3.398 0 0 0-1.508-.897Z"
})), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#journey_svg__I)",
  d: "M26.548 25.229a1.395 1.395 0 0 0-1.219-.48c-2.22.246-4.441.246-6.662 0a1.39 1.39 0 0 0-1.545 1.489c.051.645.109 1.31.157 1.839.033.371.213.7.482.929l3.314 3.314c2.395.1 4.791-.187 7.186-.86a3.42 3.42 0 0 0 2.312-2.21c-1.138-1.14-4.025-4.021-4.025-4.021Z"
})), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#journey_svg__J)",
  d: "M17.122 26.238c.051.645.109 1.31.157 1.839.057.634.54 1.146 1.169 1.247 2.366.377 4.734.377 7.101 0a1.39 1.39 0 0 0 1.169-1.247c.048-.53.106-1.194.157-1.839a1.39 1.39 0 0 0-1.546-1.49c-2.22.247-4.441.247-6.662 0a1.39 1.39 0 0 0-1.545 1.49Z"
})), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#journey_svg__K)",
  d: "M20.219 29.536c1.777.141 3.553.071 5.33-.212.63-.1 1.112-.613 1.17-1.247.047-.53.105-1.194.156-1.839a1.375 1.375 0 0 0-.343-1.028l-.003-.002a1.401 1.401 0 0 0-.605-.398l-.009-.003a1.375 1.375 0 0 0-.067-.02l-.015-.003a1.437 1.437 0 0 0-.063-.015l-.02-.004a1.52 1.52 0 0 0-.06-.01l-.022-.003a1.642 1.642 0 0 0-.06-.006l-.024-.002a1.296 1.296 0 0 0-.06-.003h-.109a1.398 1.398 0 0 0-.086.008l-.372.038-.044.005-.326.03-.09.007c-.416.035-.832.06-1.248.078h-.002c-.267.011-.536.019-.804.023h-.028c-.094.002-.188.002-.281.002l-.136.001h-.124a30.213 30.213 0 0 1-3.206-.184 1.39 1.39 0 0 0-1.546 1.489l.002.03.008.092a.309.309 0 0 0 .155.244l2.932 2.932Z"
})), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#journey_svg__L)",
  d: "M25.329 24.749c-2.22.246-4.441.246-6.661 0a1.39 1.39 0 0 0-1.546 1.488l.01.122a.303.303 0 0 0 .25.278h.002c3.076.49 6.153.49 9.229 0h.002a.303.303 0 0 0 .25-.278l.01-.121a1.39 1.39 0 0 0-1.546-1.49Z"
})), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#journey_svg__M)",
  d: "m23.382 26.97-1.046-1.046a.46.46 0 1 0-.652.652l.428.428c.424-.002.847-.014 1.27-.034Z"
})), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#journey_svg__N)",
  d: "M21.997 26.699a.462.462 0 1 0 0-.924.462.462 0 0 0 0 .924Z"
})), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "journey_svg__a",
  x1: 4.5,
  x2: 35.5,
  y1: 4.5,
  y2: 44,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FF7F4F"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#F00E7B"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "journey_svg__b",
  x1: 16.707,
  x2: 16.707,
  y1: 10.815,
  y2: 14.684,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#74AEF8"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#403DC1"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "journey_svg__c",
  x1: 17.958,
  x2: 18.985,
  y1: 27.071,
  y2: 32.612,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#6F3DC1",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#3D4AC1"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "journey_svg__d",
  x1: 27.285,
  x2: 27.285,
  y1: 10.815,
  y2: 14.684,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#74AEF8"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#403DC1"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "journey_svg__e",
  x1: 26.038,
  x2: 25.011,
  y1: 27.071,
  y2: 32.612,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#4E85FB",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#403DC1"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "journey_svg__f",
  x1: 17.284,
  x2: 17.284,
  y1: 35.701,
  y2: 36.959,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FDD689"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FAB927"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "journey_svg__g",
  x1: 18.69,
  x2: 16.016,
  y1: 36.703,
  y2: 34.03,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#B55CFD"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#7000FF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "journey_svg__h",
  x1: 27.553,
  x2: 27.553,
  y1: 35.701,
  y2: 36.959,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FDD689"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FAB927"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "journey_svg__i",
  x1: 28.959,
  x2: 26.285,
  y1: 36.704,
  y2: 34.03,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#B55CFD"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#7000FF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "journey_svg__j",
  x1: 21.998,
  x2: 21.998,
  y1: 32.746,
  y2: 35.098,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFCF42"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FFB500"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "journey_svg__k",
  x1: 22.517,
  x2: 22.517,
  y1: 34.619,
  y2: 28.748,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFB500",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FF7000"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "journey_svg__l",
  x1: 20.584,
  x2: 16.44,
  y1: 35.892,
  y2: 31.318,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFB500",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FF7000"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "journey_svg__m",
  x1: 30.483,
  x2: 25.143,
  y1: 35.781,
  y2: 30.034,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFB500",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FF7000"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "journey_svg__n",
  x1: 16.967,
  x2: 16.967,
  y1: 31.947,
  y2: 35.374,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C058FF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#7000FF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "journey_svg__o",
  x1: 27.026,
  x2: 27.026,
  y1: 31.947,
  y2: 35.374,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C058FF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#7000FF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "journey_svg__p",
  x1: 33.278,
  x2: 33.278,
  y1: 22.894,
  y2: 23.641,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#B55CFD"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#7000FF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "journey_svg__q",
  x1: 10.72,
  x2: 10.72,
  y1: 22.894,
  y2: 23.641,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#B55CFD"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#7000FF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "journey_svg__r",
  x1: 12.685,
  x2: 16.401,
  y1: 24.651,
  y2: 29.319,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#74AEF8"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#403DC1"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "journey_svg__s",
  x1: 14.529,
  x2: 10.756,
  y1: 25.488,
  y2: 21.715,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#4E85FB",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#403DC1"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "journey_svg__t",
  x1: 7.344,
  x2: 10.414,
  y1: 16.208,
  y2: 20.765,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFF2E8"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#E7D2B9"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "journey_svg__u",
  x1: 31.312,
  x2: 27.596,
  y1: 24.651,
  y2: 29.319,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#74AEF8"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#403DC1"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "journey_svg__v",
  x1: 34.085,
  x2: 31.085,
  y1: 25.42,
  y2: 22.421,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#4E85FB",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#3D6CC1"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "journey_svg__w",
  x1: 36.652,
  x2: 33.582,
  y1: 16.208,
  y2: 20.765,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFF2E8"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#E7D2B9"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "journey_svg__x",
  x1: 20.411,
  x2: 35.549,
  y1: 19.9,
  y2: 24.568,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#74AEF8"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#403DC1"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "journey_svg__y",
  x1: 21.998,
  x2: 21.998,
  y1: 27.71,
  y2: 33.252,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#4E85FB",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#403DC1"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "journey_svg__z",
  x1: 23.272,
  x2: 21.862,
  y1: 23.519,
  y2: 11.609,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#4E85FB",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#3D6CC1"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "journey_svg__A",
  x1: 22.828,
  x2: 19.528,
  y1: 19.73,
  y2: 17.999,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#4E85FB",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#403DC1"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "journey_svg__B",
  x1: 24.449,
  x2: 21.149,
  y1: 20.557,
  y2: 18.825,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#4E85FB",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#403DC1"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "journey_svg__C",
  x1: 24.779,
  x2: 25.289,
  y1: 23.239,
  y2: 23.987,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#B55CFD"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#7000FF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "journey_svg__D",
  x1: 20.923,
  x2: 21.452,
  y1: 19.662,
  y2: 20.191,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FF8FC5"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#7000FF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "journey_svg__E",
  x1: 26.015,
  x2: 26.525,
  y1: 23.501,
  y2: 24.249,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#B55CFD"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#7000FF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "journey_svg__F",
  x1: 22.544,
  x2: 23.073,
  y1: 20.489,
  y2: 21.017,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FF8FC5"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#7000FF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "journey_svg__G",
  x1: 21.998,
  x2: 21.998,
  y1: 14.111,
  y2: 18.668,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFF2E8"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#E7D2B9"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "journey_svg__H",
  x1: 21.995,
  x2: 21.995,
  y1: 10.599,
  y2: 17.259,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFCF42"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FFB500"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "journey_svg__I",
  x1: 26.71,
  x2: 20.05,
  y1: 31.674,
  y2: 25.014,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#4E85FB",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#403DC1"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "journey_svg__J",
  x1: 21.998,
  x2: 21.998,
  y1: 26.179,
  y2: 30.847,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#74AEF8"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#403DC1"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "journey_svg__K",
  x1: 22.227,
  x2: 21.935,
  y1: 29.183,
  y2: 25.282,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#4E85FB",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#403DC1"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "journey_svg__L",
  x1: 21.998,
  x2: 21.998,
  y1: 25.644,
  y2: 27.734,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFF2E8"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#E7D2B9"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "journey_svg__M",
  x1: 23.262,
  x2: 20.815,
  y1: 27.502,
  y2: 25.055,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#ED7103",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#993C15"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "journey_svg__N",
  x1: 21.997,
  x2: 21.997,
  y1: 25.863,
  y2: 26.61,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#B55CFD"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#7000FF"
})))));
export { SvgJourney as ReactComponent };
export default "data:image/svg+xml;base64,ZXhwb3J0IGRlZmF1bHQgX193ZWJwYWNrX3B1YmxpY19wYXRoX18gKyAiZGYzYTIyMGRkNmZmMTIyMTI4MmViZTUwMWRlNGVmMDkuc3ZnIjs=";